import React from "react";
import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";

interface LightPreviewNoticeProps {
  className?: string;
}

/**
 * Small slide-in notice shown during onboarding to clarify preview limitations.
 */
export const LightPreviewNotice: React.FC<LightPreviewNoticeProps> = ({ className }) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: -12, y: -12 }}
      animate={{ opacity: 1, x: 0, y: 0 }}
      transition={{ duration: 0.45, ease: "easeOut" }}
      className={`inline-flex items-start gap-2 rounded-md border bg-background px-3 py-2 shadow-sm ${
        className ? className : ""
      }`}
    >
      <Sparkles className="h-4 w-4 text-primary mt-0.5" />
      <p className="text-xs text-muted-foreground leading-relaxed">
        <span className="mr-1">✨</span>
        This is a light preview. Create a free account to unlock full site mapping, deeper research, and advanced AI models.
      </p>
    </motion.div>
  );
};

export default LightPreviewNotice;


